<app-content-wrapper
  [title]="'reservations.title'">
  <div class="box-wrapper">
    <p-inputgroup>
      <div class="px-4">
        <mat-card class="app-card" style="width: 100%">
          <app-breadcrumb [items]="breadCrumbItems" (onSelection)="onStageSelection($event)"
            [selectedIndex]="formComponent">
          </app-breadcrumb>
          @if (formComponent === 0) {
            <app-date-picker (dateSelected)="onDateSelected($event)"
            [selected]="reservation.date"></app-date-picker>
          }
          @if (formComponent === 1) {
            <app-time-picker [schedule]="schedule"
              (timeSelected)="onTimeSelected($event)" [selected]="reservation.time">
            </app-time-picker>
          }
          @if (formComponent === 2) {
            <app-num-picker (numberSelected)="onNumberSelected($event)"
              [selected]="reservation.people">
            </app-num-picker>
          }
          @if (formComponent === 3) {
            <div>
              <div>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <input pInputText placeholder="Username" />
              </div>
              <div>
                <p-inputgroup-addon>
                  <i class="pi pi-map"></i>
                </p-inputgroup-addon>
                <p-select [(ngModel)]="selectedCity" [options]="cities" optionLabel="name"
                  placeholder="City" />
                </div>
              </div>
            }
          </mat-card>
        </div>
      </p-inputgroup>
    </div>
  </app-content-wrapper>
